var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container lottery-contain"},[(!_vm.$route.query.terminal)?_c('van-nav-bar',{staticClass:"lottery-nav",attrs:{"title":"","fixed":"","z-index":10,"left-arrow":""},on:{"click-left":_vm.clickNavBack}}):_vm._e(),_c('div',{staticClass:"lottery-content",on:{"click":_vm.onJoin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }